import React from 'react';

interface EditBookIconProps {
  className?: string;
}

const EditBookIcon: React.FC<EditBookIconProps> = ({ className }) => (
  <svg 
    className={className}
    width="20" 
    height="20" 
    viewBox="0 0 20 20" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M11.7167 14.7167L18.45 7.98333L12.05 1.58333L5.31667 8.31667V14.7167H11.7167Z" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M13.7167 2.58333L17.4167 6.28333" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

export default EditBookIcon;
